// extracted by mini-css-extract-plugin
export default {"error":"error__-sUkD","header":"header__+ZyQt","form":"form__NLki+","input":"input__H4MUh"};